import styles from './index.module.scss';
import { useEffect, useState } from 'react';
import { factorMapStr } from '@/utils/contants/caseSimulation';
import { Display } from '@/components/Display/Display';
const lockImg = require('@/assets/images/simulation/lock.webp');
const unlockImg = require('@/assets/images/simulation/un_lock.webp');
const FactorCard = (props) => {
    const { sections = [], curData = {}, handleChangeCurSection } = props;
    const [cardData, setCardData] = useState([]);
    // 计算左侧和右侧卡片的索引（循环逻辑）
    const getLeftIndex = (curIndex) => {
        // 中间项索引 -1，若小于0则取最后一个
        if (curIndex === 0) {
            return sections.length - 1;
        }
        return curIndex - 1;
    };

    const getRightIndex = (curIndex) => {
        if (curIndex === sections.length - 1) {
            return 0;
        }
        return curIndex + 1;
    };
    const getCardData = (curIndex) => {
        const leftIndex = getLeftIndex(curIndex);
        const rightIndex = getRightIndex(curIndex);
        return [sections[leftIndex], sections[curIndex], sections[rightIndex]];
    };
    const onClickCard = (card) => {
        if (card.locked) {
            return;
        }
        let index = sections.findIndex((item) => item.section_id === card.section_id);
        let data = getCardData(index);
        setCardData(data);
        handleChangeCurSection(sections[index]);
    };

    useEffect(() => {
        if (curData.section_id) {
            onClickCard(curData);
        }
    }, [curData.section_id]);

    return (
        <div className={styles.container}>
            {cardData.map((card, index) => (
                <div
                    key={card.section_id}
                    // data-position={getPosition(index)}
                    onClick={() => onClickCard(card)}
                    data-index={index}
                    className={`${styles.card}`}
                    data-locked={card?.locked}
                >
                    <Display show={index !== 1}>
                        <div data-locked={card?.locked} className={styles.cardLock}>
                            <img src={card?.locked ? lockImg : unlockImg} alt="" />
                        </div>
                    </Display>

                    <div className={styles.cardTitle}>{card?.title}</div>
                    <div className={styles.cardBadge}>{factorMapStr[card?.section_id]}</div>

                    <div className={styles.cardNumber}>{'0' + (card?.originalIndex + 1)}</div>
                </div>
            ))}
        </div>
    );
};
export default FactorCard;
